@if (loader) {
<div style="padding: 149px !important;">
    <ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
</div>
}
<div class="mainContainer">
    @if (!loader) {
<div style="width: 97.5% !important;" class="card m-3">
        <div class="card-body scrollable-form">
            <form [formGroup]="form" novalidate>
                <div formArrayName="rows">
                    <div class="row flex-nowrap">
                        <div class="col-md-2 col-label">
                            <label class="a-form-label col-label-text">Partnership Name</label>
                        </div>
                        <div class="col-md-2 col-label">
                            <label class="a-form-label col-label-text">Partner Name</label>
                        </div>
                        <div class="col-md-1 col-label">
                            <label class="a-form-label col-label-text">Partnership EIN</label>
                        </div>
                        <div class="col-md-1 col-label">
                            <label class="a-form-label col-label-text">Partner EIN</label>
                        </div>
                        <div class="col-md-2 col-label">
                            <label class="a-form-label col-label-text">Select Partnership</label>
                        </div>
                        <div class="col-md-2 col-label">
                            <label class="a-form-label col-label-text">Select Partner</label>
                        </div>
                        <div class="col-md-2 col-label">
                            <label class="a-form-label col-label-text">Posting Partner</label>
                        </div>

                    </div>
                    @for (row of formRows.controls; track $index; let i = $index) {
<div [formGroupName]="i">
                        <div class="row flex-nowrap">
                            <div class="col-md-2">
                                <div class="form-group">
                                    <ap-field [fieldId]="'InvestmentName'" [title]="''">
                                        <input appkit-field formControlName="InvestmentName" aria-label="Investment Name" />
                                    </ap-field>
                                </div>
                            </div>

                            <div class="col-md-2">
                                <div class="form-group">
                                    <ap-field [fieldId]="'InvestorName'" [title]="''">
                                        <input appkit-field formControlName="InvestorName" aria-label="Investor Name" />
                                    </ap-field>
                                </div>
                            </div>

                            <div class="col-md-1">
                                <div class="form-group">
                                    <ap-field [fieldId]="'InvestmentTaxId'" [title]="''">
                                        <input appkit-field formControlName="InvestmentTaxId" aria-label="Investment Tax Id" />
                                    </ap-field>
                                </div>
                            </div>
                            <div class="col-md-1">
                                <div class="form-group">
                                    <ap-field [fieldId]="'InvestorTaxId'" [title]="''">
                                        <input appkit-field formControlName="InvestorTaxId" aria-label="Investor Tax Id" />
                                    </ap-field>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <select id="Pship_CC_Key" formControlName="Pship_CC_Key" class="form-control"
                                    (change)="onPshipDropdownChange($event, i)">
                                        @for (item of pshipDropdown; track $index) {
<option [value]="item.PSHIP_CC_KEY">
                                            {{item.PSHIP_DTLS}}
                                        </option>
}
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    @if (isLoadingMap[i]) {
<ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="true"></ap-loading>
}
                                    @if (!isLoadingMap[i]) {
<select id="Ptr_CC_key_{{i}}" formControlName="Ptr_CC_key" class="form-control"
                                        (change)="onSelectChange($event, i)">
                                        @for (item of ptrDropdownMap[i] || []; track $index; let j = $index) {
<option [value]="item.PTR_CC_KEY">
                                            {{item.PTR_DTLS}}
                                        </option>
}
                                    </select>
}
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <ap-field [fieldId]="'Posting_Ptr'" [title]="''" [disabled]="true">
                                        <input appkit-field formControlName="Posting_Ptr" aria-label="Posting Ptr" />
                                    </ap-field>
                                </div>
                            </div>
                        </div>
                    </div>
}
                </div>
            </form>
        </div>
    </div>
}
    <div class="a-modal-footer modal-footer pad-zero" style="float: right; display: flex; justify-content: flex-end; width: 100%;">

        <ap-button [label]="'CANCEL'" class="ap-mr-spacing-3" [btnType]="'primary'"
            (onClick)="cancel()">
        </ap-button>
        <div>
            <ap-button [btnType]="'primary'" [label]="'SAVE'" class="ap-mr-spacing-3"
                (onClick)="save()"></ap-button>
        </div>

    </div>
</div>